// Components==============
import ColorProfile from 'components/UI/ColorProfile/ColorProfile';
import { motion } from 'framer-motion';
import { useMediaQ } from 'hooks/useMediaQ';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import { getColorProfileSize } from 'utilities/getColorProfileSize';
import './Colors.module.scss';
// =========================

const framerParent = {
  animate: {
    transition: { staggerChildren: 0.1 },
  },
};

const framerChild = {
  initial: {
    x: '-50%',
    y: '-50%',
    scale: 0,
  },
  animate: {
    x: '-50%',
    y: '-50%',
    scale: 1,
  },
};

export default function Colors() {
  const query = useMediaQ('min', 525);

  const data = useRedux((state) => state.authentication?.user?.color_profile);
  const translate = useTranslate();

  if (!data) return <></>;

  if (!query)
    return (
      <>
        <div styleName="wrapper">
          <ColorProfile data={data} />
        </div>

        <p styleName="description">
          {translate('reflection.color-profile-description')}
        </p>
      </>
    );

  return (
    <motion.div
      styleName="wrapper "
      variants={framerParent}
      initial="initial"
      animate="animate"
      exit="initial"
    >
      {data
        .sort((a, b) => b.percentage - a.percentage)
        .map((phase, index) => (
          <motion.div
            variants={framerChild}
            key={phase.name}
            styleName={`phase ${phase.name}`}
            style={{
              width: getColorProfileSize(phase.percentage, index, 1.7),
              height: getColorProfileSize(phase.percentage, index, 1.7),
            }}
          >
            <h3>{phase.name}</h3>
          </motion.div>
        ))}
    </motion.div>
  );
}
